import { useLocalStorage } from 'react-use';
import { initialSettings, type SettingsType } from './SettingsContext';

function useStorageSettings() {
  return useLocalStorage<SettingsType>('settings', initialSettings);
}

export default useStorageSettings;
